import { TableColumnDef } from '../../../utils/tableColumns';
import { MemberSortField } from '../types';

export type CheckinColumnId =
    | 'member'
    | 'patientId'
    | 'activatedAt'
    | 'careManager'
    | 'checkinStatus'
    | 'currentCheckinDate'
    | 'scheduledDate'
    | 'notificationPhase';

/**
 * Single source of truth for the Check-in members list columns. Only the member and activation
 * columns are sortable — the check-in dates and statuses are not fields the endpoint sorts by.
 */
export const CHECKIN_COLUMNS: TableColumnDef<CheckinColumnId, MemberSortField>[] = [
    { id: 'member', label: 'Member', size: '3fr', alwaysVisible: true, sortField: 'last_name' },
    { id: 'patientId', label: 'Patient Id', size: '1.5fr' },
    { id: 'activatedAt', label: 'Activated At', size: '2fr', sortField: 'activated_at' },
    { id: 'careManager', label: 'Care Manager', size: '2.4fr' },
    { id: 'checkinStatus', label: 'Check-in Status', size: '2fr' },
    { id: 'currentCheckinDate', label: 'Current Check-in Date', size: '2fr' },
    { id: 'scheduledDate', label: 'Scheduled Date', size: '2fr', defaultVisible: false },
    { id: 'notificationPhase', label: 'Notification Phase', size: '2fr', defaultVisible: false }
];

export const CHECKIN_COLUMNS_STORAGE_KEY = 'ep:columns:checkin-members';
